import React from 'react';
import { isNotUndefined } from '../../../lib/isNotUndefined';
import { isMastheadCategoryMenu, isMastheadGalleryMenu, } from '../../../utils/contentful';
import { ActiveSubmenuContextProvider } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { SideFlyoutMenu } from './SideFlyoutMenu';
import { SideMenu } from './SideMenu';
import { NavThemeProvider } from '../NavThemeProvider';
import { Wait } from '../Wait';
export const NavBarCompact = ({ forcedUserState, colors, className, }) => {
    const { mastheadData } = useS4AMastheadContext();
    const headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    const hasFlyout = headerEntry === null || headerEntry === void 0 ? void 0 : headerEntry.fields.centerNav.filter(isNotUndefined).find(item => isMastheadGalleryMenu(item) || isMastheadCategoryMenu(item));
    if (!mastheadData) {
        return React.createElement(Wait, null);
    }
    return (React.createElement(NavThemeProvider, { colors: colors },
        React.createElement(ActiveSubmenuContextProvider, null,
            React.createElement("div", { className: className }, hasFlyout ? (React.createElement(SideFlyoutMenu, { forcedUserState: forcedUserState })) : (React.createElement(SideMenu, { forcedUserState: forcedUserState }))))));
};
//# sourceMappingURL=index.js.map